export enum PanelType {
  info = 'info',
  enterCover = 'enterCover',
  startAnime = 'startAnime',
  tourTip = 'tourTip',
  categoryConfig = 'categoryConfig',
  globalSettings = 'globalSettings',
  uiColor = 'uiColor',
  copyright = 'copyright',
  logo = 'logo',
  language = 'language',
  customGroup = 'customGroup',
  customButton = 'customButton',
  music = 'music',
  mask = 'mask',
  sandTable = 'sandTable',
  loading = 'loading',
  search = 'search',
  interactive = 'interactive',
  vipView = 'vipView',
}
